export const listTypes = Object.freeze({
  ASSESSMENTS: "assessments",
  QUESTIONS: "questions"
});
